import { render, staticRenderFns } from "./ksCustomerChurnRegionPage.vue?vue&type=template&id=75ca33d7&scoped=true&"
import script from "./ksCustomerChurnRegionPage.vue?vue&type=script&lang=js&"
export * from "./ksCustomerChurnRegionPage.vue?vue&type=script&lang=js&"
import style0 from "./ksCustomerChurnRegionPage.vue?vue&type=style&index=0&id=75ca33d7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ca33d7",
  null
  
)

export default component.exports